import type { JobTimeEntry } from "./types";

export function recentOrderIds(
  entries: Pick<JobTimeEntry, "employee_id" | "order_id" | "status" | "start_time" | "end_time" | "created_at">[],
  employeeId: string,
  selectableIds: ReadonlySet<string>,
  limit = 5
): string[] {
  const timestamp = (entry: typeof entries[number]) => {
    const value = Date.parse(entry.end_time || entry.start_time || entry.created_at);
    return Number.isFinite(value) ? value : 0;
  };
  const sorted = entries.filter(entry => entry.employee_id === employeeId && entry.status !== "cancelled" && selectableIds.has(entry.order_id))
    .sort((a, b) => timestamp(b) - timestamp(a) || a.order_id.localeCompare(b.order_id));
  return [...new Set(sorted.map(entry => entry.order_id))].slice(0, Math.max(0, limit));
}

export function normalizeJobNumber(value: string): string {
  return value.trim().toLocaleLowerCase("de-DE").replace(/[\s\-–—/]+/g, "");
}

export function findOrderByNumber<T extends { id: string; job_number: string }>(orders: T[], input: string):
  { kind: "found"; order: T } | { kind: "missing" | "ambiguous" | "empty" } {
  const number = normalizeJobNumber(input);
  if (!number) return { kind: "empty" };
  const matches = orders.filter(order => normalizeJobNumber(order.job_number) === number);
  if (matches.length === 1) return { kind: "found", order: matches[0] };
  return { kind: matches.length ? "ambiguous" : "missing" };
}
